import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditOrganizationalUnitRequestFailure() {
      return getState().isFailure;
    },
    isEditOrganizationalUnitRequestPending() {
      return getState().isPending;
    },
    isEditOrganizationalUnitRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
